import { render, staticRenderFns } from "./Sticky.vue?vue&type=template&id=b0a22f22&scoped=true&"
import script from "./Sticky.vue?vue&type=script&lang=js&"
export * from "./Sticky.vue?vue&type=script&lang=js&"
import style0 from "./Sticky.vue?vue&type=style&index=0&id=b0a22f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a22f22",
  null
  
)

export default component.exports